// ── glossary.js — 외식업 한↔중 고정 용어집 ─────────────────────────────────
// 일반 번역기/LLM이 자주 틀리는 식자재·조리·매장 운영 용어를 손으로 고정한다.
// 예) 대파(大葱)와 쪽파(小葱)를 둘 다 "葱"으로 뭉개거나,
//     깻잎을 芝麻叶(참깨잎)로, 다진마늘을 어색한 표현으로 내놓는 경우가 잦다.
//
// 조회 순서: 이 용어집 → Firestore 공용 캐시 → Claude Haiku (utils/translate.js)
// 여기 있는 단어는 API를 아예 타지 않으므로 정확도·속도·비용이 모두 유리하다.
//
// 표기: 중국 대륙 간체자 기준.
// 추가 규칙: 사장님이 현장에서 쓰는 표현이 우선. 사전적으로 맞아도 주방에서
//            안 쓰는 말이면 쓰지 않는다.

export const GLOSSARY = {
  // ── 채소 ──────────────────────────────────────────────────────────────
  '양파': '洋葱',
  '대파': '大葱',
  '쪽파': '小葱',
  '실파': '细香葱',
  '마늘': '大蒜',
  '깐마늘': '去皮蒜',
  '다진마늘': '蒜蓉',
  '생강': '生姜',
  '다진생강': '姜蓉',
  '당근': '胡萝卜',
  '감자': '土豆',
  '고구마': '红薯',
  '무': '白萝卜',
  '알타리무': '小萝卜',
  '배추': '大白菜',
  '알배추': '娃娃菜',
  '양배추': '卷心菜',
  '적양배추': '紫甘蓝',
  '상추': '生菜',
  '깻잎': '紫苏叶',
  '시금치': '菠菜',
  '부추': '韭菜',
  '미나리': '水芹',
  '쑥갓': '茼蒿',
  '청경채': '上海青',
  '브로콜리': '西兰花',
  '콜리플라워': '花菜',
  '파프리카': '彩椒',
  '피망': '青椒',
  '고추': '辣椒',
  '청양고추': '青阳辣椒',
  '홍고추': '红辣椒',
  '오이': '黄瓜',
  '애호박': '西葫芦',
  '단호박': '南瓜',
  '가지': '茄子',
  '토마토': '西红柿',
  '방울토마토': '圣女果',
  '콩나물': '黄豆芽',
  '숙주나물': '绿豆芽',
  '연근': '莲藕',
  '우엉': '牛蒡',
  '옥수수': '玉米',
  '완두콩': '豌豆',
  '아스파라거스': '芦笋',
  '셀러리': '芹菜',
  '파': '葱',
  '고사리': '蕨菜',
  '도라지': '桔梗',
  '토란': '芋头',
  '마': '山药',

  // ── 버섯 ──────────────────────────────────────────────────────────────
  '버섯': '蘑菇',
  '표고버섯': '香菇',
  '느타리버섯': '平菇',
  '팽이버섯': '金针菇',
  '새송이버섯': '杏鲍菇',
  '양송이버섯': '口蘑',
  '목이버섯': '木耳',

  // ── 육류 ──────────────────────────────────────────────────────────────
  '소고기': '牛肉',
  '쇠고기': '牛肉',
  '등심': '牛外脊',
  '안심': '牛里脊',
  '채끝': '西冷',
  '갈비': '排骨',
  '소갈비': '牛排骨',
  '우삼겹': '牛五花',
  '차돌박이': '牛胸肉',
  '양지': '牛腩',
  '사태': '牛腱',
  '돼지고기': '猪肉',
  '삼겹살': '五花肉',
  '목살': '梅花肉',
  '앞다리살': '前腿肉',
  '뒷다리살': '后腿肉',
  '돼지갈비': '猪排骨',
  '항정살': '猪颈肉',
  '등갈비': '肋排',
  '닭고기': '鸡肉',
  '닭다리': '鸡腿',
  '닭가슴살': '鸡胸肉',
  '닭봉': '鸡翅根',
  '닭날개': '鸡翅',
  '닭발': '鸡爪',
  '오리고기': '鸭肉',
  '양고기': '羊肉',
  '베이컨': '培根',
  '소시지': '香肠',
  '햄': '火腿',
  '다짐육': '肉馅',
  '간': '肝',

  // ── 수산물 ────────────────────────────────────────────────────────────
  '고등어': '青花鱼',
  '갈치': '带鱼',
  '삼치': '马鲛鱼',
  '명태': '明太鱼',
  '동태': '冻明太鱼',
  '코다리': '半干明太鱼',
  '황태': '干明太鱼',
  '오징어': '鱿鱼',
  '낙지': '小章鱼',
  '문어': '章鱼',
  '새우': '虾',
  '대하': '大虾',
  '칵테일새우': '虾仁',
  '게': '螃蟹',
  '꽃게': '梭子蟹',
  '조개': '蛤蜊',
  '바지락': '花蛤',
  '홍합': '青口',
  '굴': '牡蛎',
  '전복': '鲍鱼',
  '멸치': '小鳀鱼',
  '다시마': '海带',
  '미역': '裙带菜',
  '김': '海苔',
  '연어': '三文鱼',
  '참치': '金枪鱼',
  '어묵': '鱼饼',
  '게맛살': '蟹柳',
  '쭈꾸미': '短蛸',

  // ── 조미료·양념 ───────────────────────────────────────────────────────
  '소금': '盐',
  '설탕': '白糖',
  '후추': '胡椒粉',
  '간장': '酱油',
  '진간장': '生抽',
  '국간장': '汤酱油',
  '양조간장': '酿造酱油',
  '된장': '大酱',
  '고추장': '辣椒酱',
  '쌈장': '包饭酱',
  '초고추장': '醋辣酱',
  '고춧가루': '辣椒粉',
  '참기름': '香油',
  '들기름': '紫苏油',
  '식용유': '食用油',
  '올리브유': '橄榄油',
  '식초': '醋',
  '맛술': '料酒',
  '미림': '味淋',
  '물엿': '糖稀',
  '올리고당': '低聚糖',
  '매실청': '梅子汁',
  '다시다': '牛肉粉',
  '미원': '味精',
  '조미료': '调味料',
  '카레': '咖喱',
  '케첩': '番茄酱',
  '마요네즈': '蛋黄酱',
  '머스터드': '芥末酱',
  '굴소스': '蚝油',
  '두반장': '豆瓣酱',
  '액젓': '鱼露',
  '멸치액젓': '鳀鱼露',
  '새우젓': '虾酱',
  '참깨': '芝麻',
  '통깨': '白芝麻',
  '깨소금': '芝麻盐',
  '월계수잎': '香叶',
  '베이킹파우더': '泡打粉',

  // ── 곡물·면·가공 ──────────────────────────────────────────────────────
  '쌀': '大米',
  '찹쌀': '糯米',
  '밀가루': '面粉',
  '부침가루': '煎饼粉',
  '튀김가루': '炸粉',
  '전분': '淀粉',
  '감자전분': '土豆淀粉',
  '빵가루': '面包糠',
  '국수': '面条',
  '소면': '细面',
  '칼국수': '刀切面',
  '라면사리': '拉面',
  '당면': '粉条',
  '쫄면': '筋面',
  '냉면': '冷面',
  '우동': '乌冬面',
  '떡': '年糕',
  '떡볶이떡': '炒年糕条',
  '만두': '饺子',
  '만두피': '饺子皮',
  '두부': '豆腐',
  '순두부': '嫩豆腐',
  '유부': '油豆腐',
  '묵': '凉粉',
  '식빵': '吐司',

  // ── 유제품·계란 ───────────────────────────────────────────────────────
  '계란': '鸡蛋',
  '달걀': '鸡蛋',
  '메추리알': '鹌鹑蛋',
  '우유': '牛奶',
  '생크림': '淡奶油',
  '버터': '黄油',
  '치즈': '奶酪',
  '모짜렐라치즈': '马苏里拉奶酪',
  '슬라이스치즈': '芝士片',
  '연유': '炼乳',
  '요거트': '酸奶',

  // ── 소모품·매장 자재 ──────────────────────────────────────────────────
  '비닐봉투': '塑料袋',
  '위생장갑': '一次性手套',
  '고무장갑': '橡胶手套',
  '랩': '保鲜膜',
  '호일': '锡纸',
  '키친타올': '厨房纸',
  '종이컵': '纸杯',
  '나무젓가락': '一次性筷子',
  '숟가락': '勺子',
  '젓가락': '筷子',
  '포크': '叉子',
  '빨대': '吸管',
  '일회용기': '一次性餐盒',
  '포장용기': '打包盒',
  '물티슈': '湿巾',
  '세제': '洗洁精',
  '락스': '消毒液',
  '수세미': '洗碗布',
  '행주': '抹布',
  '쓰레기봉투': '垃圾袋',
  '앞치마': '围裙',
  '마스크': '口罩',

  // ── 매장 운영 용어 ────────────────────────────────────────────────────
  '단가표': '单价表',
  '발주서': '订货单',
  '발주': '订货',
  '재고': '库存',
  '재고관리': '库存管理',
  '실사': '盘点',
  '입고': '入库',
  '출고': '出库',
  '유통기한': '保质期',
  '원산지': '原产地',
  '거래처': '供应商',
  '업체': '供应商',
  '공급처': '供应商',
  '업체 미지정': '未指定供应商',
  '매입': '采购',
  '매출': '营业额',
  '원가': '成本',
  '판매가': '售价',
  '마진': '利润',
  '레시피': '配方',
  '메뉴': '菜单',
  '반제품': '半成品',
  '완제품': '成品',
  '신선식품': '生鲜',
  '공산품': '干货',
  '소모품': '消耗品',
  '원재료': '原材料',
  '식재료': '食材',
  '주방': '厨房',
  '홀': '前厅',
  '냉장': '冷藏',
  '냉동': '冷冻',
  '상온': '常温',
  '규격': '规格',
  '단위': '单位',
  '수량': '数量',
  '기준량': '基准量',
  '총 생산량': '总产量',
  '인분': '人份',
  '1인분': '一人份',
  '코드': '编号',
  '재료명': '食材名称',
  '품목': '品项',
  '품목명': '品项名称',

  // ── 단위 ──────────────────────────────────────────────────────────────
  '개': '个',
  '봉': '袋',
  '팩': '盒',
  '박스': '箱',
  '병': '瓶',
  '캔': '罐',
  '근': '斤',
  '망': '网袋',
  '단': '把',
  '포기': '棵',
  '마리': '条',
  '장': '张',
  '줄': '条',
  '세트': '套',

  // ── 공통 UI (Phase 4에서 확장) ────────────────────────────────────────
  '저장': '保存',
  '취소': '取消',
  '삭제': '删除',
  '수정': '修改',
  '추가': '添加',
  '검색': '搜索',
  '전체': '全部',
  '확인': '确认',
  '닫기': '关闭',
  '설정': '设置',
  '인쇄': '打印',
  '합계': '合计',
  '날짜': '日期',
  '메모': '备注',
  // ════ 조리 (V109 — 레시피 병기용) ════════════════════════════════════════
  // ── 조리 동작 ──────────────────────────────────────────────────
  '썰다': '切',
  '자르다': '切断',
  '다지다': '剁碎',
  '채썰기': '切丝',
  '어슷썰기': '斜切',
  '깍둑썰기': '切丁',
  '편썰기': '切片',
  '반달썰기': '切半月片',
  '송송썰기': '切小段',
  '저미다': '切薄片',
  '볶다': '炒',
  '굽다': '烤',
  '삶다': '煮',
  '데치다': '焯水',
  '끓이다': '煮开',
  '졸이다': '收汁',
  '조리다': '焖煮',
  '찌다': '蒸',
  '튀기다': '炸',
  '부치다': '煎',
  '지지다': '煎',
  '무치다': '拌',
  '버무리다': '拌匀',
  '섞다': '搅拌',
  '젓다': '搅动',
  '치대다': '揉',
  '반죽하다': '和面',
  '재우다': '腌制',
  '절이다': '腌',
  '불리다': '泡发',
  '헹구다': '冲洗',
  '씻다': '洗',
  '담그다': '浸泡',
  '우려내다': '熬出味',
  '식히다': '放凉',
  '데우다': '加热',
  '해동하다': '解冻',
  '냉장하다': '冷藏',
  '냉동하다': '冷冻',
  '걸러내다': '过滤',
  '체에 거르다': '过筛',
  '물기를 빼다': '沥干',
  '기름을 빼다': '控油',
  '거품을 걷다': '撇浮沫',
  '간을 맞추다': '调味',
  '간을 보다': '尝味道',
  '뿌리다': '撒',
  '끼얹다': '浇',
  '담다': '装盘',
  '플레이팅': '摆盘',
  '비비다': '拌匀',
  // ── 손질 ────────────────────────────────────────────────────────
  '손질하다': '处理',
  '다듬다': '修整',
  '껍질을 벗기다': '去皮',
  '깎다': '削皮',
  '씨를 빼다': '去籽',
  '꼭지를 따다': '去蒂',
  '뿌리를 자르다': '去根',
  '핏물을 빼다': '去血水',
  '비늘을 치다': '刮鳞',
  '내장을 제거하다': '去内脏',
  '뼈를 발라내다': '剔骨',
  '힘줄을 제거하다': '去筋',
  '기름기를 제거하다': '去油脂',
  '칼집을 내다': '划刀口',
  '두드리다': '拍松',
  '포를 뜨다': '片开',
  '갈다': '磨碎',
  '으깨다': '捣碎',
  // ── 화력·상태 ──────────────────────────────────────────────────
  '센불': '大火',
  '중불': '中火',
  '약불': '小火',
  '예열': '预热',
  '끓는 물': '开水',
  '찬물': '冷水',
  '미지근한 물': '温水',
  '한소끔 끓이다': '煮开一次',
  '노릇하게': '炒至金黄',
  '투명해질 때까지': '炒至透明',
  '숨이 죽을 때까지': '炒至变软',
  '속까지 익히다': '熟透',
  '반쯤 익히다': '半熟',
  '바삭하게': '酥脆',
  '촉촉하게': '保持湿润',
  '걸쭉하게': '浓稠',
  '한 김 식히다': '稍微放凉',
  // ── 계량·단위 ──────────────────────────────────────────────────
  '그램': '克',
  '킬로그램': '公斤',
  '밀리리터': '毫升',
  '리터': '升',
  '큰술': '大勺',
  '작은술': '小勺',
  '한 줌': '一把',
  '약간': '少许',
  '적당량': '适量',
  '한 꼬집': '一撮',
  '배치': '批次',
  '사용량': '用量',
  '총 산출량': '总产出',
  // ── 조리 도구 ──────────────────────────────────────────────────
  '도마': '砧板',
  '프라이팬': '平底锅',
  '웍': '炒锅',
  '중식도': '中式菜刀',
  '국자': '勺子',
  '뒤집개': '锅铲',
  '집게': '夹子',
  '체': '筛子',
  '거름망': '滤网',
  '채반': '沥水篮',
  '믹싱볼': '搅拌盆',
  '저울': '秤',
  '계량컵': '量杯',
  '계량스푼': '量勺',
  '타이머': '定时器',
  '온도계': '温度计',
  '오븐': '烤箱',
  '튀김기': '炸锅',
  '가스레인지': '燃气灶',
  '인덕션': '电磁炉',
  '전자레인지': '微波炉',
  '블렌더': '搅拌机',
  '밀폐용기': '密封容器',
  '비닐장갑': '一次性手套',
  // ── 레시피·인쇄물 ──────────────────────────────────────────────
  '조리 순서': '制作步骤',
  '조리법': '做法',
  '보관방법': '保存方法',
  '냉장보관': '冷藏保存',
  '냉동보관': '冷冻保存',
  '실온보관': '常温保存',
  '원가율': '成本率',
  '1인분 원가': '每份成本',
  '이익': '利润',
  '비중': '占比',
  '주의': '注意',
  '알레르기': '过敏原',
  '담당': '负责人',
  '작성일': '制作日期',
  '완성': '完成',
  '준비물': '准备物品',
};

// 공백을 무시한 조회용 인덱스 — "다진 마늘"과 "다진마늘"을 같게 본다.
const NORMALIZED = {};
for (const [ko, zh] of Object.entries(GLOSSARY)) {
  NORMALIZED[ko.replace(/\s+/g, '')] = zh;
}

/**
 * 용어집에서 찾는다. 없으면 null.
 * @param {string} ko 한국어 원문
 * @returns {string|null} 중국어 (간체) 또는 null
 */
export function lookupGlossary(ko) {
  const raw = String(ko || '').trim();
  if (!raw) return null;
  return GLOSSARY[raw] || NORMALIZED[raw.replace(/\s+/g, '')] || null;
}

export const GLOSSARY_SIZE = Object.keys(GLOSSARY).length;
